import SiteMap from '@/services/SiteMap';

export default interface NavigationNode {
	id: number | null;
	siteMap: SiteMap;
	isRootNode: boolean;
	hideChildren: boolean;
	enabled: boolean;
	cssClass: string | null;
	nodes: NavigationNode[];
	uid?: string;
}

export function navNodeFactory() {
	return {
		id: null,
		siteMap: {} as SiteMap,
		nodes: [],
		isRootNode: false,
		enabled: true,
		cssClass: "",
		hideChildren: false,
	} as NavigationNode;
}